import { Component, Input, OnInit } from '@angular/core';
import { InputComponent } from '../input/input.component';

@Component({
  selector: 'app-navbar',
  templateUrl: './navbar.component.html',
  styleUrls: ['./navbar.component.scss']
})
export class NavbarComponent implements OnInit {

  constructor() { }
  @Input() background = '';
  @Input() redShape = '';
  @Input() color ='';
  @Input() redSize ='';
  ngOnInit(): void {
  }

}
